/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue, Watch} from "vue-property-decorator";
import {UserModule} from '@/store/modules/user'

import {
    getCompanyList,
    setFinanceContract,
    getUserInfo,
    getFinanceContractInfoById,
    getOrgInfo,

    getCustomerList,
    setFinanceContractById, getDownloadFinanceContractById
} from '@/api/financial-center'
import {getMarketCooperationPrevLevel} from '@/api/market'
import {formatDate} from '@/utils/timeFilter'
import {menuBtn} from '@/utils/menu_level2_button'
import {getDraftById, setDraftById} from '@/api/draft'
import {delNullProperty} from "@/utils";
import {Loading} from "element-ui";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import {makeUploadSignature} from '@/utils/uploadMd5'

Vue.directive('el-select-loadmore1', { // 指令懒加载
    // bind表示这个自定义指令一绑定到dom上，就开始自动执行
    bind(el: any, binding: any) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
            /**
             * scrollHeight 获取元素内容高度(只读)
             * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
             * clientHeight 读取元素的可见高度(只读)
             * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
             * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
             */
            const condition = this.scrollHeight - this.scrollTop-1 <= this.clientHeight;
            if (condition) {
                binding.value();
            }
        });
    },
    // 表示dom插入到页面上的时候自动执行
    // 这些函数都有两个参数，一个是el(使用自定义指令的元素), 一个是binding(记录自定义指令信息的对象)
    inserted(el, binding) {
        el.focus()
    },
    // 表示自定义指令后面的值更新的时候，自动执行
    update() {
        // console.log(this.scrollHeight , this.scrollTop, '11');
    }
})

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class ContractAdd extends Vue {
    limit = 20
    tableKey = Math.random()
    orderList = []
    orderDialogSelect: any = []

    studentDialog = false
    studentDialogInputValue = ''
    studentDialogTaleData = []
    studentDialogTotal = 0
    studentDialogPage = 1
    orderDialogFilterTotal = 0
    studentDialogTableLoading = false
    studentConfirmList = {
        name: '',
        id: '',
        customerId: null,
    }
    studentDialogSelect = {
        name: '',
        id: '',

        customerId: NaN,

    }

    orderDialog = false
    orderDialogInputValue = ''
    orderDialogTaleData = []
    orderDialogTotal = 0
    orderAllTotal = null
    orderDialogPage = 1
    orderDialogTableLoading = false
    orderDialogSelectTable = []
    // commission_totals = 0
    tableData = []
    formData = {
        mainPart: '0',
        signTypes: '0',
        sealTypes: '0',
        fileTypes: '0',
        directorUserId: '',
        deparmentId: '',
        deparment: '',
        company: '',
        remark: '',
        fileId: '',
        url: '',
        psnName:'',
        psnAccount:'',
        contractAt: null,
        customerId : null,
        marketCooperationId : null,
        customerOrParternerName:'', // 新加的
        directorUserName:'', //负责人
    }

    companyList = []

    moneyCertificatesArr = []
    fileList = []

    disabledButton = false
    saveDraftDialogShow = false
    errorDialogShow = false
    isDraft = '0'

    backMoneyId: number = null
    orderId: number = null
    editUserName = '' // 编辑的时候使用
    editCreatedAt: Date = null // 编辑的时候用来返显
    draftId: number = null // 草稿id
    backMoneyStatus = ''
    name = '' //开户名称
    formRule = {
        // mainPart: [{required: true, message: '请选择合同主体', trigger: 'change'}],
        // sealTypes: [{required: true, message: '请选择', trigger: 'change'}],
        // signTypes: [{required: true, message: '请选择签署类型', trigger: 'change'}],
        // fileTypes: [{required: true, message: '请选择用印文件', trigger: 'change'}],
        company: [{required: true, message: '请选择用印公司', trigger: 'change'}],
        contractAt: [{required: true, message: '请选择合同签订期限', trigger: ['change', 'blur']}],
        // remark: [{required: true, message: '请输入备注', trigger: ['blur']}],
        customerOrParternerName: [{required: true, message: `请输入${this.formData.mainPart=='0'?'学生':'合作伙伴'}名称`, trigger: ['change', 'blur']}],
    }
    total: 0
    contractId = null
    authorizeUserInfoUrl = ''
    windowsOpen = {}
    windowsOpenLoop = null
    certCompanyShow = false
    certPersonalShow = false
    authorizeUserInfoCompanyUrl = ''
    title = null
    psnAccount = null
    customerList = []
    customerNameLimit = 20
    customerName = '' //客户名称
    customerListLoading = false
    marketCooperationIdListIsLoading = false
    // marketCooperationId?: number = null
    marketCooperationIdList = [] // 关联上级数据
    marketLevelPage = 1
    marketLevelSize = 20
    cooperativePartnerName = ''
    marketCooperationName = ''
    // customerId = null
    customerType = ''
    file = null
    link = ''
    linkShow = false
    recordId = null
    url = ''
    contractCode = ''
    contractOpenUrl = ''
    isReplace = false
    previewName= ''
    previewVisible = false
    previewPath = ''
    directorUserId = ''
    contractLoading = false
    source = '' // 具体来源名称
    loading = false
    signature = ''

    get userName() {
        return UserModule.userName
    }

    get department() {
        return UserModule.department
    }

    get userId() {
        return UserModule.userId
    }


    get baseUrl() {
        // let str = '/api/eqianbao/uploadFile'
        let str = '/fileApi/eqianbao/uploadFile'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'eqianbao/uploadFile'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'eqianbao/uploadFile'
            }
        }
        return str
    }

    created() {

        if (this.$route.query.contractId) {
            this.contractId = Number(this.$route.query.contractId)
            this.getFinanceContractInfoById()
        }
        //查询认证状态
        this.getUserInfo()
        this.getCompanyList()
        this.getCustomerList()//学生
        this.getMarketCooperationPrevLevel() // 合作伙伴

    }

    menuBtn = menuBtn

    // 去认证
    goCERT() {
        if (this.authorizeUserInfoUrl) {
            this.windowsOpen = window.open(this.authorizeUserInfoUrl, '_blank');
            this.windowsOpenLoop = setInterval(() => {
                if ((this.windowsOpen as any).closed) {
                    clearInterval(this.windowsOpenLoop)
                    this.windowsOpenLoop = null
                    window.location.reload()
                }
            }, 1000)
        }
    }

    // 去认证 公司/机构
    goCERTCompany() {
        if (this.authorizeUserInfoCompanyUrl) {
            this.windowsOpen = window.open(this.authorizeUserInfoCompanyUrl, '_blank');
            this.windowsOpenLoop = setInterval(() => {
                if ((this.windowsOpen as any).closed) {
                    clearInterval(this.windowsOpenLoop)
                    this.windowsOpenLoop = null
                    window.location.reload()
                }
            }, 1000)
        }
    }




    // 查询认证信息
    async getUserInfo() {
        const loading = this.$loading({
            lock: true,
            text: '认证结果查询中……',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });

        const result: any = await getUserInfo()
        if (result.authorizeUserInfo == false) {
            this.certPersonalShow = true
            this.authorizeUserInfoUrl = result.url
            loading.close();
            this.$message.error('认证未通过，请去认证！')
        } else {
            this.$message.success('认证通过！')
            loading.close();
            this.certPersonalShow = false

        }
    }

    // 查询机构认证
    async getOrgInfo(company) {
        const loading = this.$loading({
            lock: true,
            text: '认证结果查询中……',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });

        const result: any = await getOrgInfo({
            company: company
        })

        if (result.authorizeUserInfo == false) {
            this.certCompanyShow = true
            this.authorizeUserInfoCompanyUrl = result.url
            loading.close();
            this.$message.error('认证未通过，请去认证！')
        } else {
            this.$message.success('认证通过！')
            loading.close();
            this.certCompanyShow = false
        }

    }


    async getFinanceContractInfoById() {
        this.isReplace = true
        this.loading = true
       await getFinanceContractInfoById(delNullProperty({
            id: this.contractId,
        })).then((data: any)=>{
           const {financeContract} = data
           this.formData = financeContract
           this.customerName = financeContract.mainPartName
           this.marketCooperationName = financeContract.mainPartName
           this.customerType = financeContract.customerType
           // this.formData.marketCooperationId =
           this.$set(this.formData,'this.formData.marketCooperationId', financeContract.marketCooperationId)
           this.formData.customerId = financeContract.customerId
           this.formData.customerOrParternerName = financeContract.mainPartName
           this.formData.contractAt = financeContract.contractAt.split('&')
           this.formData.deparment = financeContract.directorDepartmentName
           this.formData.directorUserName = financeContract.directorUserRealName
           this.source = financeContract.customerSource


           this.contractCode = financeContract.code
           this.contractOpenUrl = financeContract.url
           this.formData.directorUserId = financeContract.directorUserId
           // this.directorUserIdChange()
           this.loading = false
       }).catch(err=>{
           this.loading = false
       })

    }


    // async directorUserIdChange(val) {
    //     const selectedItem = this.userList.find(item => item.id === val);
    //     this.formData.deparment = selectedItem.departmentName
    // }



    // 去空格
    trimAll(ele) {
        if (typeof ele === 'string') {
            return ele.split(' ').join('');

        } else {
            console.error(`${typeof ele} is not the expected type, but the string type is expected`)
        }

    }

    /*保存*/
    clickSubmintButton() {
        // 校验

        // if (!this.formData.company) {
        //     this.$message.error('用印公司不可为空')
        //     return;
        // }
        //
        // if (this.formData.mainPart === '0' && !this.formData.customerId) {
        //     this.$message.error('客户名称不可为空')
        //     return;
        // } else if (this.formData.mainPart === '1' && !this.formData.marketCooperationId) {
        //     this.$message.error('合作伙伴名称不可为空')
        //     return;
        // }
        //
        // if (!this.formData.contractAt) {
        //     this.$message.error('合同签订期限不可为空')
        //     return;
        // }



        const obj = {
            mainPart: this.formData.mainPart,
            signTypes: this.formData.signTypes,
            sealTypes: this.formData.sealTypes,
            fileTypes: this.formData.fileTypes,
            customerId: this.formData.customerId,
            customerType: this.customerType,
            marketCooperationId: this.formData.marketCooperationId,
            remark: this.formData.remark,
            directorUserId: this.formData.directorUserId,
            fileId: this.formData.fileId,
            company: this.formData.company,
            contractAt: this.changeTime(this.formData.contractAt as Date[]),
            url: this.formData.url,
            psnName: this.trimAll(this.formData.psnName),
            psnAccount: this.trimAll(this.formData.psnAccount),
            types: '1' ,// 2023-9-19 增加合同类型
        };


        (this.$refs.formRef as HTMLFormElement).validate((valid: boolean) => {
            if (valid) {
                if(!this.formData.fileId){
                    this.$message.error('请上传合同')
                    return;
                }

                if (this.formData.mainPart === '0' && this.formData.signTypes === "1") {
                    if (!this.formData.psnName) {
                        this.$message.error('签署方姓名不可为空')
                        return;
                    }
                    if (!this.formData.psnAccount) {
                        this.$message.error('签署方手机号不可为空')
                        return;
                    }

                }

                this.disabledButton = true;
                this.loading = true
                setFinanceContract(delNullProperty(obj)).then((data) => {
                    this.$message.success(`新建成功`)
                    this.saveDraftDialogShow = false
                    this.loading = false
                    setTimeout(() => {
                        this.closePage()
                    }, 1500)
                }).catch((err: Error) => {
                    if (err) {
                        this.disabledButton = false
                        this.loading = false
                    }
                    if (err.message === '审批流报错') {
                        this.errorDialogShow = true
                    }
                })
            }
        })
    }

    changeMainpart(val) {

        this.customerName= ''
        this.formData.customerOrParternerName= ''
        this.formData.customerId = ''
        this.customerType = ''
        this.formData.marketCooperationId = ''

    }

    /*编辑保存*/
    clickEditSubmitButton() {
        // 校验
        if (this.formData.mainPart === '0' && this.formData.signTypes === "1") {
            if (!this.formData.psnName) {
                this.$message.error('签署方姓名不可为空')
                return;
            }
            if (!this.formData.psnAccount) {
                this.$message.error('签署方手机号不可为空')
                return;
            }
        }
        const obj = {
            id: this.contractId,
            mainPart: this.formData.mainPart,
            signTypes: this.formData.signTypes,
            sealTypes: this.formData.sealTypes,
            fileTypes: this.formData.fileTypes,
            customerId: this.formData.customerId,
            customerType: this.customerType,
            marketCooperationId: this.formData.marketCooperationId,
            remark: this.formData.remark,
            directorUserId: this.formData.directorUserId,
            fileId: this.formData.fileId,
            company: this.formData.company,
            url: this.formData.url,
            contractAt: this.changeTime(this.formData.contractAt as Date[]),
            psnName:  this.trimAll(this.formData.psnName),
            psnAccount:  this.trimAll(this.formData.psnAccount),
        }
        this.disabledButton = true
        this.loading = true
        setFinanceContractById(delNullProperty(obj)).then(res => {
            this.$message.success('保存成功，页面即将关闭')
            this.loading = false
            setTimeout(() => {
                this.closePage()
            }, 1500)
        }).catch(err => {
            if (err.message === '审批流报错') {
                this.errorDialogShow = true
            }
            this.disabledButton = false
            this.loading = false
        })
    }

    choiceStudent(e) {
        this.studentDialogPage = 1
        this.studentDialogInputValue = ''
        this.studentDialog = true
        // this.getFinanceOrderMarketCooperationList()
        e.target.blur()
    }


    // 订单列表取消
    handleOrderDialog() {
        this.orderDialogSelectTable.map(item => {
            this.tableData.map(items => {
                if (item.id !== items.id) {
                    const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
                    orderDialogTable.clearSelection()
                }
            })
        })

        if (this.tableData.length > 0) {
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            this.tableData.forEach(row => {
                orderDialogTable.toggleRowSelection(row, true)
            });
        } else {
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            orderDialogTable.clearSelection()
        }
        this.orderDialog = false
    }

    orderDialogConfirm() {
        const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
        this.tableData = []
        orderDialogTable.selection.forEach(item => {
            this.tableData.push({
                ...item,
                extraPrice: 0,
                priceSum: Number(item.commissionPrice)
            })
        })

        this.orderDialog = false
    }

    beforeUpload(file) {
        this.contractLoading = true;//上传时显示
        this.$message("正在上传中，请稍后")
        // md5加密
        this.signature = makeUploadSignature('crm', file.name)
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                resolve(true)
            };
            reader.onerror = (error) => {
                reject(error)
            }
        })
    }
    uploadSuccess(res) {
        const {data} = res
        this.fileList.push({name: '图片', url: data.ossUrl})
        this.formData.fileId = data.fileId
        this.formData.url = data.url
        this.isReplace = false
        if (this.formData.fileId) {
            this.$message.success('上传成功')
            this.contractLoading = false
        } else {
            this.$message.success('合同上传中…')
        }
    }

    uploadError() {
        this.$message.error('上传失败')
    }


    handlePreview(file) {

        if (file.response) {
            this.previewPath = file.response.data.url
        } else {
            this.previewPath = file.url
        }
        this.previewName = file.name
        this.previewVisible = true
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }

    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }


    closePage() {
        window.close()
    }


    handleCompanyList(val) {
        this.getOrgInfo(val)
    }


    // 所属公司列表
    async getCompanyList() {
        const data: any = await getCompanyList()
        this.companyList = data.companyList
    }


    // 时间区间过滤器
    changeTime(val: Date[]): string {
        if (val == null) return ''
        let time = ''
        val.forEach((item: any) => {
            time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
        })
        time = time.slice(0, time.length - 1)
        return time
    }


    async getCustomerList() {
        const data: any = await getCustomerList({limit: this.customerNameLimit, customerName: this.name})
        this.customerList = [...this.customerList, ...data.customerList]
        const result = []
        const obj = {}
        for (let i = 0; i < this.customerList.length; i++) {
            if (!obj[this.customerList[i].customerId]) {
                result.push(this.customerList[i]);
                obj[this.customerList[i].customerId] = true;
            }
        }
        this.customerList = result
    }

    async getFoucsCustomerList() {
        if (this.customerList.length == 0 && !this.customerName) {
            this.name = ''
            this.customerNameLimit = 20
            const result: any = await getCustomerList({
                limit: this.customerNameLimit,
                customerName: this.name
            })
            this.customerList = result.customerList
        }
        if (this.customerName) {
            this.customerList = []
            this.customerNameLimit = 20
            const result: any = await getCustomerList({
                limit: this.customerNameLimit,
                customerName: this.customerName
            })
            this.customerList = result.customerList
        }
    }


    clearCustomerList(e) {
        if (!this.customerName) {
            this.name = ''
            this.customerNameLimit = 20
            this.getCustomerList()
        }
    }

    async remoteMethod(query: any) {
        this.name = query
        this.customerNameLimit = 20
        if (query !== '') {
            const result: any = await getCustomerList({limit: this.customerNameLimit, customerName: this.name})
            this.customerList = result.customerList
        } else {
            this.customerList = []
            this.getCustomerList();
        }
    }

    clearCustomer() {
        this.customerName = ''
        this.name = ''
        this.customerNameLimit = 20
        this.getCustomerList()
    }

    customerChange(val) {
        this.formData.customerId = val
        this.customerList.forEach(item => {
            if (item.customerId == val) {
                this.customerName = item.customerName
                this.formData.customerOrParternerName = item.customerName
                this.customerType = item.customerType
                this.source = item.customerSource
            }
        })
        this.$forceUpdate();
    }

    loadmore() {
        this.customerNameLimit += 20;
        if (this.customerNameLimit == 100) {
            return
        }
        this.getCustomerList();
    }


    // 合作伙伴
     marketCooperationIdChange(val) {
        this.marketCooperationIdList.forEach(item => {
            if (item.id == val) {

                this.$set(this.formData,'marketCooperationId',val)
                this.$set(this.formData,'customerOrParternerName',item.name)
            }
        })
         this.$forceUpdate();
     }

    async remoteCooperativePartnerMethod(query: any) {
        this.cooperativePartnerName = query
        this.marketLevelPage = 1
        this.marketLevelSize = 20
        if (query !== '') {
            const result: any = await getMarketCooperationPrevLevel(
                {
                    page: this.marketLevelPage,
                    limit: this.marketLevelSize,
                    name: query,
                }
            )
            this.marketCooperationIdList = result.marketCooperationList
        }
    }


    clearCooperativePartner() {
        this.marketCooperationIdList = []
        this.formData.marketCooperationId = null
        this.cooperativePartnerName = null
        this.marketLevelPage = 1
        this.marketLevelSize = 20
        this.getMarketCooperationPrevLevel()
    }

    cooperativePartnerLoadmore() {

        this.marketLevelPage = 1
        this.marketLevelSize += 20
        this.getMarketCooperationPrevLevel();
    }

    async getMarketCooperationPrevLevel() {
        const data: any = await getMarketCooperationPrevLevel(delNullProperty(
                {
                    page: this.marketLevelPage,
                    limit: this.marketLevelSize,
                    name: this.cooperativePartnerName
                }
            )
        )

        this.marketCooperationIdList = [...this.marketCooperationIdList, ...data.marketCooperationList]
        const result = []
        const obj = {}
        for (let i = 0; i < this.marketCooperationIdList.length; i++) {
            if (!obj[this.marketCooperationIdList[i].id]) {
                result.push(this.marketCooperationIdList[i]);
                obj[this.marketCooperationIdList[i].id] = true;
            }
        }
        this.marketCooperationIdList = result

    }

    handleAgree() {
        this.linkShow = false
        setTimeout(() => {
            this.closePage()
        }, 1500)
    }



    changeFile(file, fileList) {
        if (fileList.length > 1) {
            fileList.splice(0, 1);
        }
        this.fileList = fileList;
    }


    previewContractUrl() {
        window.open(this.contractOpenUrl, 'blank')
    }

    // 查询签署结果
    queryResult() {
        getDownloadFinanceContractById({
            id: this.contractId
        })
    }


    changeDirectorUserId(e) {
        this.formData.directorUserId = e.id
        if (e.id) {
            this.formData.deparment = e.departmentName
        }
    }

    @Watch('userId')
    handledirectorUserId(userId: string) {
        if(!this.formData.directorUserId){
            this.formData.directorUserId = userId
        }
    }


    @Watch('userName')
    handledirectorUserName(userName: string) {
        if(!this.formData.directorUserName){
            this.formData.directorUserName = userName
        }
    }

    @Watch('department')
    handleChangeDepartment(department: string) {
        if (!this.formData.deparment) {
            this.formData.deparment = department
        }
    }

    @Watch('fileList')
    handleIsReplace(val) {

        if (this.contractId) {
            if (val.length > 0) {
                this.isReplace = false
            }
        }
    }

}
